@if (loading()) {
  <app-progress-spinner />
}

<ng-content select="[appButtonIcon]:not([iconPositionEnd])" />

@if (!loading()) {
  <span class="button__label"><ng-content></ng-content></span>
}

<ng-content select="[appButtonIcon][iconPositionEnd]" />
